import { actions } from "../constants/learningOutcomes";
import * as actionTypes from '../../models/action/learningOutcomes';

export function GetLearningOutcomesList(courseId?: string,Skip?: number, Take?: number, OrderBy?: boolean | null, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: (value: boolean) => void): actionTypes.IGetLearningOutcomesData {
    return {
        courseId,
        Take,
        Skip,
        OrderBy,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_LEARNING_OUTCOMES_LIST,
        callback
    };
}


export function addLearningOutComes(learningOutcomeValue: string, courseId: string, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: (value: boolean) => void): actionTypes.IAddLearningOutcomes {
    return {
        learningOutcomeValue,
        courseId,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.ADD_LEARNING_OUTCOMES,
        callback
    };
}

export function setLearningOutcomes(results: Array<{ learningOutcomeId: string, learningOutcomeValue: string }> | null, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: (value: boolean) => void): actionTypes.ISetLearningOutcomes {
    return {
        results,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_LEARNING_OUTCOMES,
        callback
    };
}


export function deleteLearningOutComes(learningOutcomeId: string, courseId: string, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: (value: boolean) => void): actionTypes.IDeleteLearningOutcomes {
    return {
        learningOutcomeId,
        courseId,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.DELETE_LEARNING_OUTCOMES,
        callback
    };
}

export function udpateLearningOutcomes(learningOutcomeId: string, learningOutcomeValue: string, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: (value: boolean) => void): actionTypes.IUpdateLearningOutcomes {
    return {
        learningOutcomeId,
        learningOutcomeValue,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.UPDATE_LEARNING_OUTCOMES,
        callback
    };
}

export function addLearningOutcomeForActivity(learningOutcomeId: string, activityId: string, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: (value: boolean) => void): actionTypes.IAddLearningOutcomesForActivity {
    return {
        learningOutcomeId,
        activityId,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.ADD_LEARNING_OUTCOMES_FOR_ACTIVITY,
        callback
    };
}

export function addLearningOutcomeForQuestion(learningOutcomeId: string, questionId: string, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: (value: boolean) => void): actionTypes.IAddLearningOutcomesForQuestion {
    return {
        learningOutcomeId,
        questionId,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.ADD_LEARNING_OUTCOMES_FOR_QUESTION,
        callback
    };
}

